export default __webpack_public_path__ + "static/media/all.f875880d7d55cb0ea02c7b9ccc4e8749.mp3";